<template>
  <div >
    <div v-if="this.showModal">
      <MdTitle v-bind:Text="$t('SpecialPrecautions.SpecialPrecautionsReport')" />
      <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadSpecPrec"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadSpecPrec">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      <b-row>
        <b-col lg="3" md="3" sm="12">         
          <MdSelect
            v-bind:Label="$tc('Shared.Patient',2)"
            v-bind:Options="PatientsList"
            v-bind:Model="PatientCodeModel"
            v-bind:FieldDescription="'patientName'"
            v-bind:FieldCode="'patientcode'"
            v-bind:Multiple="true"             
            :Input="ChangeDropDownPatients"
            :CustomLabel="customLabelPatients"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
              v-bind:Label="$tc('Shared.PatientStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showPatientIsActiveModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeIsActive"
              v-bind:AllowEmpty="false"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="$tc('Shared.AdmissionStatus')"
            v-bind:Options="showOptions"
            v-bind:Model="showIsActiveAdmissionModel"
            v-bind:FieldDescription="'text'"
            v-bind:FieldCode="'value'" 
            v-bind:Multiple="false"                      
            :Input="ChangeIsActiveAdmission"
            v-bind:AllowEmpty="false"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadSpecPrec"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>  
      </b-row>
      <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="space-actions"></div>
      <div class="page-actions">
        <MdButton
          v-bind:Label="$t('Shared.Back')"
          v-bind:ClassProp="'primary btn-login mx-2'"
          v-on:click="reportList"
          v-bind:Name="'btn_ReportList'"/>
        <MdButton
          v-bind:Label="$t('Shared.Report')"
          v-bind:ClassProp="'primary btn-login mx-2'"
          v-on:click="onClickShowReport"
          v-bind:Name="'btn_Print'"/>
          
        <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
          <b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
          <b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
          <b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
          <b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
        </b-dropdown>   
      </div>
    <DxPopup
      :visible="isReportVisible"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-close-button="true"
      :show-title="true"
      :hide-on-parent-scroll="true"
      :title="$t('SpecialPrecautions.SpecialPrecautionsReport')"
      @hidden="onHiddenReport"
      :resize-enabled="true"
      shading-color="rgba(0, 0, 0, 0.5)"
      height="94vh"
      width="97vw"
      @showing="onShowing"
    >
      <ReportViewer
        ref="specialPrecautions"
        :ReportName="'SpecialPrecautions'"
        :ReportTitle="$t('SpecialPrecautions.SpecialPrecautionsReport')"
        :IsAnAPIReport="true"
      />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('SpecialPrecautions.SpecialPrecautionsReport')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/PatientSpecialPrecautions/exportCSV'"
    >    
    </CSVExportHelper>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import PatientService from '@/services/patient.service';
  import DBFunctions from '@/common/DBFunctions.js'
  import SpecialPrecaution from '@/services/specialprecaution.service'
  import Utils from "@/common/utils";

  export default Vue.extend({
      name: "SpecialPrecautionsRep",
      mixins: [ ShowMessage, DBFunctions ],
      components: { DxPopup },
      props: {
        closeWindow: Function,
        patientCode: String,
        patientName: String,
        patientDOB: String,
        PatientCodeList: String,
        showModal: Boolean
      },
      data() {
          return {
              OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
              },
              isParamVisible: true,
              isReportVisible: false,
              reportParams: [],
              PatientsList:[],
              params: {
                "PatientCodeList": [],
                "Show": 'all',
                "IsActive": true,
                "IsActiveAdmission": true
              },
              PatientCodeModel:'',
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0,
                Status: true,
              },
              showOptions: [
                { value: "all", text: this.$t('Shared.All') },
                { value: "true", text:this.$t('Shared.Active') },
                { value: "false", text: this.$t('Shared.Inactive') },
              ],
              showPatientIsActiveModel: {
                "value":"true",
                "text":this.$t('Shared.Active')
              },
              showIsActiveAdmissionModel: {
                "value":"true",
                "text":this.$t('Shared.Active')
              },
              items: [],         
              fields: [
                { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' } ,
                { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' } ,
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' },
                { key: 'patientNotActive', sortable: true, label: this.$t('Shared.Active'), class: 'text-rigth' },
                { key: 'activeAdmission', sortable: true, label: this.$t('Shared.AdmissionStatus'), class: 'text-rigth' },
                { key: 'specialPrecaution', sortable: false, label: this.$t('MdPatientSpecialPrecaution.SpecialPrecaution'), class: 'text-rigth' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',    
          }
      },
      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
            if(!this.showModal)
              this.closeWindow();
          },

          onClickClose() {
            this.closeWindow()
            this.isParamVisible = false;
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pPatientCode', paramValue: this.patientCode})
            this.reportParams.push({ paramName: 'patientName', paramValue: this.patientName})
            this.reportParams.push({ paramName: 'patientDOB', paramValue: this.patientDOB})
            this.reportParams.push({ paramName: 'patientCodeList',paramValue: (this.params.PatientCodeList.length == 0) ? this.patientCode :this.params.PatientCodeList })
            this.reportParams.push({ paramName: 'isActive', paramValue: this.params.IsActive})
            this.reportParams.push({ paramName: 'isActiveAdmission', paramValue: this.params.IsActiveAdmission})
            this.reportParams.push({ paramName: 'show', paramValue: this.params.Show})
            this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
          },

          initializeParameters() {
            // Asignaciones condicionales
            this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== '' 
                ? this.params.PatientCodeList 
                : null;
            this.parameter.PatientIsActive = (this.params.IsActive === 'all') ? null : this.params.IsActive;
            this.parameter.ActiveAdmission = (this.params.IsActiveAdmission === 'all') ? null : this.params.IsActiveAdmission;
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters()
            this.isReportVisible = true
            this.$refs.specialPrecautions.buildDocument(this.reportParams)
          },

          ChangeDropDownPatients(values) {
            this.params.PatientCodeList = this.getItemsByComma(values, 'patientcode')
          },

          customLabelPatients ({ patientName, patientcode }) {
            return `${patientName} – ${patientcode}`
          },

          getPatients() {              
            PatientService.getPatientList(this.parameter)
              .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.PatientsList = response.data; 
                this.PatientsList.forEach(function(element) {
                    element.patientName = element.firstname + " " + element.lastname;   
                  });
                }      
              })
          },
          reportList() {
              this.checkExistFavorite('/app/reports/patients');
              this.$router.push({ name: "reportListPatient" }).catch(()=>{});
          },
          getItemsByComma(values, field) {
            let len = values.length;
            let valuesSeparated = [];
            if (len > 0){
              var i = 0;
              values.forEach(function(e) {   
                if(i < len-1){
                  valuesSeparated += e[field]+",";
                }else{
                  valuesSeparated += e[field];
                }
                i++;                    
              });
              return valuesSeparated;
            } else {
              return [];
            }
        },
        ChangeIsActive(item) {
          this.params.IsActive = item.value
        },
        ChangeIsActiveAdmission(item) {
          this.params.IsActiveAdmission = item.value
        },

        LoadSpecPrec(){
          this.Loading = true;
          this.$emit('load', this.Loading);
          this.items = [];
          this.currentPage = 1;
          this.parameter.PageNumber = 1;
          this.totalRows = this.items.length;         
          this.getSpecialPrecautions();           
        },

        getSpecialPrecautions() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            this.initializeParameters();
            console.log(this.parameter);
            SpecialPrecaution
              .getSpecialPrecautionReportList(this.parameter)
              .then(response => {
                  if (response.status == "200" && response.data) {
                    this.items = response.data;
                    this.items.forEach(function(element) {
                      if (element.dob)	
                        element.dob = Utils.formatterDateToString(element.dob);
                      element.patientName = element.firstname + " " + element.lastname;
                    });
                    let headerString = response.headers["x-pagination"];
                    this.Header = JSON.parse(headerString);
                    this.totalRows = this.Header.TotalCount;
                    this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                    this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
                  this.$emit('load', false);
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
                  this.$emit('load', false);
              });
          },
          pageChanged (page) {            
            this.currentPage = page;
            this.getSpecialPrecautions();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getSpecialPrecautions();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('SpecialPrecautions', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('SpecialPrecautions', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },
      },
      
  mounted () {
    if(!this.showModal) {
      this.onClickShowReport();
    } else {
      this.getPatients(); 
      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }
    }
  },
})
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
